import { render } from "./TreballsFinalsView.vue?vue&type=template&id=d0980d9a"
import script from "./TreballsFinalsView.vue?vue&type=script&lang=js"
export * from "./TreballsFinalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__